/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./parserSelector.vue?vue&type=template&id=cbaeca8a"
import script from "./parserSelector.vue?vue&type=script&lang=js"
export * from "./parserSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports